import * as React from "react"
import { useEffect } from "react"
import Router from "../router/Router"
import "react-toastify/dist/ReactToastify.css"
import "../styles/index.css"
import IToastContainer from "./ui/toast/IToastContainer"
import { bootIntercom } from "../utility"
import { User } from "../types"

const App = () => {
  useEffect(() => {
    // If user is already logged in (page refresh), boot Intercom with user data
    const userString = localStorage.getItem("user")
    const token = localStorage.getItem("token")
    if (userString && token) {
      try {
        const user = JSON.parse(userString) as User
        if (user.id) {
          bootIntercom(user)
        }
      } catch (e) {
        console.error("Error parsing user data for Intercom:", e)
      }
    }
  }, [])

  return (
    <>
      <Router />
      <IToastContainer />
    </>
  )
}

export default App
